import { useAuth } from '../../contexts/AuthContext';
import { usePlatformConfig } from '../../contexts/PlatformConfigContext';
import { useIdleSessionLogout, usePersistedLocale } from '../../hooks/index';
import { useTranslation } from '../../i18n/index';
import s from './SessionIdleGuard.module.scss';

function formatRemaining(ms: number): string {
  const totalSec = Math.max(0, Math.ceil(ms / 1000));
  const m = Math.floor(totalSec / 60);
  const sec = totalSec % 60;
  return `${m}:${String(sec).padStart(2, '0')}`;
}

export function SessionIdleGuard() {
  const { logout, user } = useAuth();
  const { sessionIdleMs } = usePlatformConfig();
  const { lang } = usePersistedLocale(user?.id ?? null);
  const t = useTranslation(lang);
  const { warning, remainingMs, extend } = useIdleSessionLogout(logout, true, sessionIdleMs);

  if (!warning) return null;

  return (
    <div className={s.backdrop} role="alertdialog" aria-modal="true" aria-labelledby="session-idle-title">
      <div className={s.panel} onClick={(e) => e.stopPropagation()}>
        <h2 id="session-idle-title" className={s.title}>
          {t.sessionIdleWarnTitle}
        </h2>
        <p className={s.body}>{t.sessionIdleWarnBody}</p>
        <p className={s.countdown} aria-live="polite">
          {formatRemaining(remainingMs)}
        </p>
        <div className={s.actions}>
          <button type="button" className={`tap ${s.extend}`} onClick={extend}>
            {t.sessionIdleExtend}
          </button>
          <button type="button" className={`tap ${s.signOut}`} onClick={() => { void logout(); }}>
            {t.sessionIdleSignOut}
          </button>
        </div>
      </div>
    </div>
  );
}
